"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSectionAboutFive100sItem = {
    key: Key | null | undefined;
    /** Detected variants: "about-item-five w-100" | "about-item-five w-100 mb-0" */
    className: string;
    /** Detected variants: "/Templates/Doccure/img/icons/about-icon-1.svg" | "/Templates/Doccure/img/icons/about-icon-2.svg" | "/Templates/Doccure/img/icons/about-icon-3.svg" */
    src: string;
    /** Detected variants: "Personalized treatment plans" | "Easy access & flexible bookings" | "Advanced ENT diagnostic technology" */
    h30Text: ReactNode;
    /** Detected variants: "Expert diagnosis and treatment for all ear-related conditions, including hearing loss and infections." | "Specialized treatment for vocal cord issues, throat pain" */
    p0Text: ReactNode;
    /** Detected variants: "about-icon" */
    div0ClassName?: string;
    /** Detected variants: "about-icon" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "" */
    div1p0Expr1?: ReactNode;
};
export type HomeFiveAboutSectionGeneratedProps = {
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAboutFive100sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSectionAboutFive100sItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "about-img" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-img-1.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "about-img" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-shape-1.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "ABOUT US" */
    sectionDiv0Div0Div1Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/title-icon1.svg" */
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Our ENT Clinic is Dedicated To" */
    sectionDiv0Div0Div1Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Providing Exceptional Care." */
    sectionDiv0Div0Div1Div0H20Span0SpanText?: ReactNode;
    /** Default: "With state of the art facilities and a team of experienced specialists, we offer diagnostic services and personalized treatment plans." */
    sectionDiv0Div0Div1Div0P0PText?: ReactNode;
    /** Default: "all_routes.aboutUs" */
    sectionDiv0Div0Div1Div2Link0LinkHref?: string;
    /** Default: "View more" */
    sectionDiv0Div0Div1Div2Link0LinkText?: ReactNode;
    sectionDiv0Div0Div1Div2Link0LinkVisible?: boolean;
    sectionDiv0Div0Div1Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "star-icon" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/star-icon.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "star-icon" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/star-icon.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    aboutSectionAboutFive100s: AboutSectionAboutFive100sItem[];
    aboutSectionAboutFive100sItemWrapper?: (item: AboutSectionAboutFive100sItem, content: ReactNode) => ReactNode;
    aboutSectionAboutFive100sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSectionAboutFive100sImageVisible?: boolean;
    aboutSectionAboutFive100sImageRenderer?: (item: AboutSectionAboutFive100sItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionAboutFive100sH3Visible?: boolean;
    aboutSectionAboutFive100sH3Renderer?: (item: AboutSectionAboutFive100sItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionAboutFive100sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAboutFive100sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSectionAboutFive100sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSectionAboutFive100sItem) => Partial<ComponentProps<"h3">>);
};

const HomeFiveAboutSectionGenerated: FC<HomeFiveAboutSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "about-img",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-img-1.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt = "about-img",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/about-shape-1.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1Div0Div0DivText = "ABOUT US",
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/title-icon1.svg",
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0H20H2Text = "Our ENT Clinic is Dedicated To",
    sectionDiv0Div0Div1Div0H20H2Visible,
    sectionDiv0Div0Div1Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0H20H2Props,
    sectionDiv0Div0Div1Div0H20Span0SpanText = "Providing Exceptional Care.",
    sectionDiv0Div0Div1Div0P0PText = "With state of the art facilities and a team of experienced specialists, we offer diagnostic services and personalized treatment plans.",
    sectionDiv0Div0Div1Div2Link0LinkHref = "all_routes.aboutUs",
    sectionDiv0Div0Div1Div2Link0LinkText = "View more",
    sectionDiv0Div0Div1Div2Link0LinkVisible,
    sectionDiv0Div0Div1Div2Link0LinkRenderer,
    sectionDiv0Div0Div1Div2Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "star-icon",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/star-icon.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "star-icon",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/star-icon.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0ImageWithBasePath0ImageProps,
    divDiv1H30H3Props,
    sectionDiv0Div0ClassName,
    aboutSectionAboutFive100s,
    aboutSectionAboutFive100sItemWrapper,
    aboutSectionAboutFive100sRenderer,
    aboutSectionAboutFive100sImageVisible,
    aboutSectionAboutFive100sImageRenderer,
    aboutSectionAboutFive100sH3Visible,
    aboutSectionAboutFive100sH3Renderer,
    aboutSectionAboutFive100sImageProps,
    aboutSectionAboutFive100sH3Props,
}) => {
    return (
        <section className="about-section-five section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-lg-6">
                        <div className="about-img-five">
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid img-2" {...(sectionDiv0Div0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="section-header section-header-five">
                            <div className="section-sub-title">
                                {" "}
                                {renderNode(sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div1Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {sectionDiv0Div0Div1Div0Div0DivText}
                            </div>
                            {renderNode(sectionDiv0Div0Div1Div0H20H2Visible, sectionDiv0Div0Div1Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div1Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div1Div0H20H2Text}
                                    {" "}
                                    <span className="d-block">{sectionDiv0Div0Div1Div0H20Span0SpanText}</span>
                                    {" "}
                                </h2>
                            ))}
                            <p>{sectionDiv0Div0Div1Div0P0PText}</p>
                        </div>
                        <div className="about-details-five">
                            {renderCollectionNode(
                                aboutSectionAboutFive100s,
                                (item: AboutSectionAboutFive100sItem) => (
                                    <div className={item.className} key={item.key}>
                                        <div className={item.div0ClassName ?? "about-icon"}>
                                            {renderItemNode(aboutSectionAboutFive100sImageVisible, aboutSectionAboutFive100sImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "about-icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof aboutSectionAboutFive100sImageProps === "function" ? aboutSectionAboutFive100sImageProps(item) : (aboutSectionAboutFive100sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        <div>
                                            {renderItemNode(aboutSectionAboutFive100sH3Visible, aboutSectionAboutFive100sH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof aboutSectionAboutFive100sH3Props === "function" ? aboutSectionAboutFive100sH3Props(item) : (aboutSectionAboutFive100sH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                            ))}
                                            <p>
                                                {item.p0Text}
                                                {" "}
                                            </p>
                                        </div>
                                    </div>
                                ),
                                aboutSectionAboutFive100sItemWrapper,
                                aboutSectionAboutFive100sRenderer
                            )}
                        </div>
                        <div className="view-more">
                            {renderNode(sectionDiv0Div0Div1Div2Link0LinkVisible, sectionDiv0Div0Div1Div2Link0LinkRenderer, (
                                <SmartLink href={sectionDiv0Div0Div1Div2Link0LinkHref} className="btn btn-white" {...(sectionDiv0Div0Div1Div2Link0LinkProps ?? {})}>
                                    {sectionDiv0Div0Div1Div2Link0LinkText}
                                    <i className="isax isax-arrow-right-1" />
                                </SmartLink>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid star-icon-1 star-5" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="img-fluid star-icon-2 star-5" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFiveAboutSectionGenerated;
